<div class="chat-page chat-redesign" [class.chat-page-conversa-aberta]="!!contatoSelecionado()">
  <section class="chat-coluna chat-coluna-lista">
    <app-lista-contatos-chat
      [contatoSelecionadoId]="contatoSelecionado()?.id"
      [modo]="modo"
      (contatoSelecionado)="selecionarContato($event)"
      (abrirMenu)="abrirMenuMobile()"
      (criarContato)="abrirCadastroContato()"
    ></app-lista-contatos-chat>
  </section>

  <section class="chat-coluna chat-coluna-conversa">
    @if (contatoSelecionado(); as contato) {
      <app-chat-conversa
        [contato]="contato"
        (voltar)="voltarParaLista()"
        (favoritoAlterado)="aoAlterarFavorito($event)"
        (atendimentoEncerrado)="aoEncerrarAtendimento($event)"
        (atendimentoTransferido)="aoTransferirAtendimento($event)"
      ></app-chat-conversa>
    } @else {
      <div class="chat-sem-conversa">
        <img src="./assets/clari-talk-logo.png" alt="" class="chat-sem-conversa-logo" />
        <span class="chat-sem-conversa-texto">Selecione um contato para abrir a conversa.</span>
      </div>
    }
  </section>
</div>
